import Tooltip from "@mui/material/Tooltip";
const ConfirmBoxNoLabel = ({ disabled = false, onClick, onCLose }) => {
  return (
    <div className="flex flex-row ">
      <Tooltip title="Are you sure you want to save?" placement="bottom" arrow>
        <button
          className="w-full inline-flex justify-center rounded-md border border-transparent shadow-sm  py-1 px-2 bg-secondary text-base font-medium text-white hover:bg-secondary focus:outline-none focus:ring-2 focus:ring-offset-2 focus:ring-secondary sm:ml-3 sm:w-auto sm:text-xs"
          onClick={onClick}
        >
          Confirm
        </button>
      </Tooltip>
      <button
        className="mt-3 w-full inline-flex justify-center rounded-md border border-gray-300 shadow-sm py-1 px-2  bg-white text-base font-medium text-gray-700 hover:bg-gray-50 focus:outline-none focus:ring-2 focus:ring-offset-2 focus:ring-primary sm:mt-0 sm:ml-3 sm:w-auto sm:text-xs"
        onClick={onCLose}
      >
        Back
      </button>
    </div>
  );
};
export default ConfirmBoxNoLabel;
